export const SET_GROUPING = 'RESERVE_DESK/SET_GROUPING';

export const SET_DATE = 'RESERVE_DESK/SET_DATE';

export const SET_FLOOR = 'RESERVE_DESK/SET_FLOOR';
